import { MobileFilesItemArray } from './../../../models/domain/mobile.files.item';

import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { LicenseManager } from '../../../managers/License.manager';
import { Product } from '../../../models/domain/product';
import { LicenseTransferLogArray } from '../../../models/domain/license.transfer.log';
import { LicenseUpgradeLogArray } from '../../../models/domain/license.upgrade.log';
import { NoteManager, NoteManagerConstructor } from '../../../managers/note.manager';
import { ssApiService } from '../../../services/ss-api.service';
import { DialogService } from '../../../services/modal-dialogs';
import { GlobalService } from '../../../services/global.service';
import { BillingCycleTypes, PaymentMethodTypes, InvoiceArray, Invoice } from '../../../models/domain/invoice';
import { LicenseStatusTypes } from '../../../models/domain/license';
import { KeyValuePair } from '../../../models/KeyValuePair';
import { NoteTypes, Note } from '../../../models/domain/note';
import { DialogTypes } from '../../../services/modal-dialogs/dialog-types';
import { BaseResponse, IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { MemberEventsService } from '../../../services/member.events.service';
import { PinService } from '../../../services/pin.service';
import { PinTypes } from '../../../models/domain/pin';
import { UpgradeSimulationTypes, UpgradeSimulation } from '../../../models/domain/upgrade.simulation';
import { PinAddRequest } from '../../../models/ss-api/requests/pin.add.request';
import { UpgradeSimulationRequest } from '../../../models/ss-api/requests/upgrade.simulation.request';
import { ConfirmDialog } from '../../confirm/confirm.dialog';
import { SalesRepresentativeArray } from '../../../models/domain/sales.representative';
import { InvoiceDetailsDialog } from '../../invoice.details/invoice.details.dialog';
import { AuditLogItemArray } from '../../../models/domain/audit.log.item';
import { LicenseAuditLogsRequest } from '../../../models/ss-api/requests/license.audit.logs.request';
import { UserRolesService } from '../../../services/user.roles.service';
import { AddInvoiceDialog } from '../../../dialogs/add.invoice/add.invoice.dialog';
import { MakePaymentDialog } from '../../../dialogs/make.payment/make.payment.dialog';
import { SortBot } from '../../../../app/helpers/sort';
import { UserRoleTypes } from '../../../models/domain/user.roles';
import { AddDiscountDialog } from '../../../../app/dialogs/add.discount/add.discount.dialog';
import { EditDiscountDialog } from '../../../../app/dialogs/edit.discount/edit.discount.dialog';

import * as moment from 'moment';
import { MemberDashboard } from '../../../models/ss-api/responses/member.dashboard.response';
import { LicenseTransferDetailsComponent } from './transfer.details/transfer.detials.component';
import { PCLimiterComponent } from './pc.limiter/pc.limiter.component';
import { LiveHubService } from '@services/livehub.service';
import { IgnoreHardwareCheckChangedRequest } from '@models/ss-api/requests/ignore.hardware.check.changed.request';
import { AddOnHistoryItemArray } from '@models/domain/addon.history.item';
import { TrialLicenseResponse, TrialProduct } from '@models/ss-api/responses/trial.license.response';
import { TrialSetRequest } from '@models/ss-api/requests/trial.set';
import { StringResponse } from '@models/ss-api/responses/string.response';

@Component({
    selector: 'license-details',
    templateUrl: './license.details.component.html',
    styleUrls: ['./license.details.component.css']
})

export class LicenseDetailsComponent implements OnInit, OnDestroy {

    @Input('Subscriptions') Subscriptions: Array<any>;
    @Input('LicenseManager') licenseManager: LicenseManager;
    @ViewChild('ActiveDownloadLink') ActiveDownloadLink: ElementRef;

	@ViewChild( 'LicenseTransferDetails' ) LicenseTransferDetails : LicenseTransferDetailsComponent;
	@ViewChild( 'PCLimiter' ) PCLimiter : PCLimiterComponent

	@Input('DashboardData') _dashboardData : MemberDashboard;

    licenseManagerSubscription: Subscription;

    TransferDetails: LicenseTransferLogArray = new LicenseTransferLogArray();
    UpgradeDetails: LicenseUpgradeLogArray = new LicenseUpgradeLogArray();
    AddOnHistoryItems: AddOnHistoryItemArray = new AddOnHistoryItemArray();

    IsBusy: boolean = false;
    NotesBusy: boolean = false;

    product: SelectItem[];
    selectedProduct: Product = new Product();
    cycle: SelectItem[];
    payMethod: SelectItem[];
    status: SelectItem[];
    backendServer: SelectItem[];
    backendServerSlected: number;
    isPinned: boolean;

    salesRepOptions: SelectItem[];
    salesRepSelected: any;

    noteManager = new NoteManager(null);
    noteChangeSubscription: Subscription;
    pinsChangeSubscription: Subscription;

    LastUpgradeSimulationType: string;

    hasYARD: boolean = true;

    YardDeviceIDCleared: boolean = false;

    YardFiles: MobileFilesItemArray;
    YardFilesSearch: string;

    // TRIAL
    TrialAvailable: boolean = false;
    Trial: TrialLicenseResponse = new TrialLicenseResponse();
    TrialProducts: SelectItem[];
    TrialSelectedProduct: TrialProduct = new TrialProduct();
    TrialStart: Date;
    TrialStop: Date;
    TrialProductEdited: boolean = false;
    TrialStartEdited: boolean = false;
    TrialStopEdited: boolean = false;

    // Invoices
    Invoices: InvoiceArray;
    InvoiceArray: Invoice[] = [];

    // Audit Logs
    AuditLogs: AuditLogItemArray;
    AuditLogStartDate: Date = new Date;
    AuditLogEndDate: Date = new Date;

    // Cancellation Stuff
    cancellationDate: Date = new Date;

    onLabel = 'Don\'t Send';

    constructor(private api: ssApiService,
        private sweetAlertService: SweetAlertService,
        public dialogService: DialogService,
        private pinService: PinService,
        public gb: GlobalService,
        private memberEvents: MemberEventsService,
        public roles: UserRolesService,
        private liveHub: LiveHubService) {

    }

    ngOnInit() {
        this.Init();
        this.licenseManagerSubscription = this.licenseManager.OnIsBusyChanged.subscribe(isBusy => { this.IsBusy = isBusy; });
        this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe(args => this.onNoteChanged(args));

        // this.licenseManager.License().Status

        this.pinsChangeSubscription = this.pinService.onPinsChanged.subscribe(() => {
            this.isPinned = this.CheckIsPinned();
        });

        this.AuditLogStartDate.setTime(this.AuditLogStartDate.getTime() - (24 * 60 * 60 * 1000) * 30); // subtract 30 days

        if (this.licenseManager.License().TerminationDate == undefined ||
            this.licenseManager.License().TerminationDate.getFullYear() == 1)
            this.cancellationDate = this.licenseManager.License().NextBillingDate;
        else
            this.cancellationDate = this.licenseManager.License().TerminationDate;
    }

    ngOnDestroy() {
        this.licenseManagerSubscription.unsubscribe();
        this.noteChangeSubscription.unsubscribe();
        this.pinsChangeSubscription.unsubscribe();
    }

    IgnoreHardwareCheckChange(){
        var request = new IgnoreHardwareCheckChangedRequest();
        request.LicenseKey = this.licenseManager.License().Key;
        request.IgnoreHardwareCheck = this.licenseManager.License().IgnoreHardwareCheck 

        this.liveHub.InvokeConnection('IgnoreHardwareCheckChanged', request);
    }

    TOSWindowCheckChange(){
        if (this.licenseManager.License().TOSWindow){
            //prepopulate the date
            this.licenseManager.License().TOSWindowContinueUntilDate = new Date(new Date().setDate(new Date().getDate() + 7));
        }
        else{
            //remove the date
            this.licenseManager.License().TOSWindowContinueUntilDate = null;
        }
    }
   
    IsVersionLiveHubCompatible(SoftwareVersion: string){
        //Check for an empty value - that will never be compatible with LiveHub
        if (SoftwareVersion === null || SoftwareVersion.length === 0 || !SoftwareVersion.trim()){
            return false;
        }

        var cleanSoftwareVersion = SoftwareVersion.replace(/\D/g,'');

        if (cleanSoftwareVersion.length < 4){
            while (cleanSoftwareVersion.length < 4){
                cleanSoftwareVersion = cleanSoftwareVersion + "0";
            }
        }

        var nmcleanSoftwareVersion = Number(cleanSoftwareVersion);

        if (isNaN(nmcleanSoftwareVersion)){
            return false;
        }

        if (nmcleanSoftwareVersion < 2620){
            return false;
        }

        return true;

    } 

    RemovePin() {
        this.pinService.DeletePinByType(this.licenseManager.License().ID, PinTypes.License);
    }

    CheckIsPinned(): boolean {
        return this.pinService.IsPinned(this.licenseManager.License().ID, PinTypes.License);
    }

    AddPin() {
        let request = new PinAddRequest();
        request.AdminID = this.gb.AdminId;
        request.PinType = PinTypes.License;
        request.RelationID = this.licenseManager.License().ID;
        this.pinService.Add(request);
    }

    private InitProducts() {
        this.product = [];

        this.licenseManager.AvailableProdutcs().forEach(product => {
            this.product.push({ label: product.Name, value: product });
        });

        this.selectedProduct = this.licenseManager.Product();
    }

    private InitBillingCycle() {
        this.cycle = [];
        this.cycle.push({ label: 'Monthly', value: BillingCycleTypes.Monthly });
        this.cycle.push({ label: 'Yearly', value: BillingCycleTypes.Annually });
    }

    private InitPayMethod() {
        this.payMethod = [];
        this.payMethod.push({ label: 'Credit Card', value: PaymentMethodTypes.CreditCard });
        this.payMethod.push({ label: 'Cash or Check', value: PaymentMethodTypes.CashOrCheck });
        this.payMethod.push({ label: 'Wire Transfer', value: PaymentMethodTypes.BankTransfer });
    }

    private InitLicenseStatuses() {
        this.status = [];
        this.status.push({ label: 'Registered', value: LicenseStatusTypes.Registered });
        this.status.push({ label: 'Open', value: LicenseStatusTypes.Open });
        this.status.push({ label: 'Cancelled (Registered)', value: LicenseStatusTypes.Cancelled });
        this.status.push({ label: 'Cancelled (Open)', value: LicenseStatusTypes.CancelledOpen });
        // this.status.push({ label: 'Disabled', value: LicenseStatusTypes.Disabled });
        if ( this.roles.RestrictedAccess(0) )
            this.status.push({ label: 'Terminated', value: LicenseStatusTypes.Terminated });
        else
            this.status.push({ label: 'Cancelled', value: LicenseStatusTypes.Terminated });
    }

    public CancellationDateChanged() {
        this.licenseManager.newEntity.License.TerminationDate = this.cancellationDate;

        if (moment(this.cancellationDate).isBefore(moment())) {
            this.licenseManager.License().Status = LicenseStatusTypes.Terminated;
        }

        console.log("Termination Date Changed:", this.licenseManager.newEntity.License.TerminationDate);
    }

    private InitBackendServerOptions() {
        this.backendServer = [];

        if (this.licenseManager.AvailablePoolStudioSettingsGroups().length == 0)
            return;

        this.licenseManager.AvailablePoolStudioSettingsGroups().forEach(
            (item) => {
                this.backendServer.push({ label: item.Name, value: item.ID });
            }
        );

        if (this.licenseManager.License().AssignedPoolStudioSettingsGroup == undefined ||
            this.licenseManager.License().AssignedPoolStudioSettingsGroup == 0)
            this.backendServerSlected = this.licenseManager.AvailablePoolStudioSettingsGroups().find(x => x.IsDefault == true).ID;
        else
            this.backendServerSlected = this.licenseManager.License().AssignedPoolStudioSettingsGroup;

    }

    public BackendServerChanged(newServer) {
        this.licenseManager.License().AssignedPoolStudioSettingsGroup = newServer;
    }

    private InitNoteManager() {
        //
    }

    private async InitSalesReps() {

        let reps: SalesRepresentativeArray;

        await this.gb.GetSalesRepresentatives(true, true, this.licenseManager.License().SalesRepresentativeID)
            .then(response => {
                reps = response;
            })
            .catch(() => {
                    reps = new SalesRepresentativeArray();
                });

        this.salesRepOptions = [];

        this.salesRepOptions.push({ label: 'None', value: -1 });

        reps.forEach(item => {
            this.salesRepOptions.push({ label: item.FirstName + ' ' + item.LastName, value: item.ID });
        });

        this.salesRepSelected = this.licenseManager.License().SalesRepresentativeID ? this.licenseManager.License().SalesRepresentativeID : null;

    }

    private Init() {
        this.InitBillingCycle();
        this.InitLicenseStatuses();
        this.InitPayMethod();
        this.InitProducts();
        this.InitBackendServerOptions();
        this.InitNoteManager();
        this.InitSalesReps();
        // this.InitUpdaterSettings();
    }

    TabChanged(e: any) {

		console.log("TabChanged : " + e.index);

        if (e.index == 2){
            this.LoadTrial();
        }
        else if (e.index == 3) {
            this.LoadInvoices();
        } else if (e.index == 4) {
			this.GetAddOnHistory();
        } else if (e.index == 5) {
			this.GetTransferLog();
        } else if( e.index == 6 ) {
			this.PCLimiter.GetLicensePCs();
        } else if (e.index == 7) {
            this.GetUpgradeLog();
        } else if (e.index == 8) {
            this.GetAuditLogs();
        } else if (e.index == 9) {
            // notes
            this.GetNotes();
        } else if (e.index == 11) {
            this.GetYardFiles();
        }

    }

    StrippedFolderName(folder) {
        return folder.replace(new RegExp('%', 'g'), '');
    }

    IconForFile(extension) {
        switch (extension) {
            case '.zip':
                return 'fa-file-zip-o';
            case '.pdf':
                return 'fa-file-pdf-o';
            case '.jpg':
            case '.jpeg':
            case '.png':
            case '.gif':
            case '.svg':
            case '.tiff':
                return 'fa-file-image-o';
            case '.mp3':
            case '.wav':
            case '.aac':
                return 'fa-file-sound-o';
            case '.mp4':
            case '.avi':
            case '.mkv':
                return 'fa-file-video-o';
            case '.dat':
            case '.config':
            case '.pdb':
            case '.ini':
            case '.xml':
                return 'fa-file-code-o';
            case '.exe':
                return 'fa-file';
            case '.txt':
                return 'fa-file-text-o';
            default:
                return 'fa-file-o';
        }
    }

    GetAuditLogs(reload: boolean = false) {

        if (this.AuditLogs != undefined && !reload)
            return;

        this.IsBusy = true;

        let request = new LicenseAuditLogsRequest();
        request.LicenseID = this.licenseManager.License().ID;
        request.StartDate = this.AuditLogStartDate;
        request.EndDate = this.AuditLogEndDate;

        let disposable = this.api.GetAuditLicenseAudits(request).subscribe(response => {
            disposable.unsubscribe();
            this.AuditLogs = response.Data;
            this.IsBusy = false;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    GetYardFiles() {
        let disposable = this.api.GetMobileFilesByLicenseID(this.licenseManager.License().ID).subscribe(response => {
            this.YardFiles = response.Data;
            disposable.unsubscribe();
        });
    }

    EditDiscount(discount: any) {
        let disposable = this.dialogService.addDialog(EditDiscountDialog, {
            title: 'Edit Discount',
            Discount: discount,
            LicenseID: this.licenseManager.License().ID
        }).subscribe(response => {

            if (response) {

                let DiscountIndex = this.licenseManager.License()['DiscountItems'].indexOf(response.Discount);

                if (response.isDeleted) {
                    // this.licenseManager.Load(this.licenseManager.License().ID.toString())
                    this.licenseManager.License()['DiscountItems'].splice(DiscountIndex, 1);
                } else if (response.Discount) {
                    this.licenseManager.License()['DiscountItems'][DiscountIndex] = response.Discount;
                }

            }

            disposable.unsubscribe();
        });
    }

    AddDiscount() {
        let disposable = this.dialogService.addDialog(AddDiscountDialog, {
            title: 'Add Discount',
            LicenseID: this.licenseManager.License().ID
        }).subscribe(response => {
            if (response) {
                if (response.AddedAmount) response.Amount = response.AddedAmount;
                response.DateTimeCreated = new Date();
                this.licenseManager.License()['DiscountItems'].push(response);
            }
            disposable.unsubscribe();
        });
    }

    AddNote() {
        // add new

        let license = this.licenseManager.License();
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.LicenseKey, license.ID);
        let noteData = new NoteManagerConstructor();

        noteData.MemberID = license.MemberID;
        noteData.NoteType = type;
        noteData.RelationInfo = license.Key;
        noteData.RelationObject = license;

    }

    onNoteChanged(args: EntityChangedArgs<Note>) {

        let licenseID = Note.GetNoteTypeValue(args.Original.NoteTypeList, NoteTypes.LicenseKey);

        if (licenseID != this.licenseManager.License().ID)
            return;

        this.licenseManager.Original().License.HasNotes = true;
        this.licenseManager.License().HasNotes = true;
        this.GetNotes();

    }

    GetNotes() {

        if (!this.licenseManager.License().HasNotes)
            return;

        let noteSubscription = this.noteManager.OnDataLoaded.subscribe(
            () => {
                noteSubscription.unsubscribe();
                this.NotesBusy = false;
            }
        );

        let licenseID = this.licenseManager.License().ID;
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.LicenseKey, licenseID);

        this.NotesBusy = true;
        this.noteManager.LoadType(type, 0, false, '', this.licenseManager.License());

    }



    BillingCycleChanged(newBillingCycle: BillingCycleTypes) {
        switch (newBillingCycle) {
            case BillingCycleTypes.Monthly:
                this.licenseManager.License().ProductRecurringAmount = this.selectedProduct.PriceMonthly;
                break;

            case BillingCycleTypes.Annually:
                this.licenseManager.License().ProductRecurringAmount = this.selectedProduct.PriceYearly;
                break;
        }
    }

    TransferChanged(disabled: boolean) {

        let Title = 'Change \'Transfer Disabled\'';
        let SubTitle = this.licenseManager.License().Key;
        let Message = '';

        if (!disabled) {
            Message = 'Are you sure you want to Enable transfer for this License Key?<br>The user will be able to transfer the key after this action.';
        } else {
            Message = 'Are you sure you want to Disable transfer for this License Key?<br>The user will NOT be able to transfer the key after this action.';
        }

        this.TransferChangedConfirm(Title, SubTitle, Message);

    }


    TransferChangedConfirm(title: string, subTitle: string, message: string) {


    }


    LicenseStatusChanged(status: LicenseStatusTypes) {

        switch (status) {
            case LicenseStatusTypes.Cancelled:
                // set to cancelled
                this.LicenseStatusChangeConfirm(
                    'Cancel License Key',
                    this.licenseManager.License().Key,
                    'Are you sure you want to cancel the License Key: ' + this.licenseManager.License().Key
                );

                break;

            case LicenseStatusTypes.Disabled:
                // set to disabled
                this.LicenseStatusChangeConfirm(
                    'Disable License Key',
                    this.licenseManager.License().Key,
                    'Are you sure you want to disable the License Key: ' + this.licenseManager.License().Key
                );

                break;
        }

        if (status == LicenseStatusTypes.Terminated)
            this.licenseManager.newEntity.License.TerminationDate = this.licenseManager.License().NextBillingDate; 

    }

    LicenseStatusChangeConfirm(title: string, subTitle: string, message: string) {


    }

    Confirm() {
        let disposable = this.dialogService.addDialog(ConfirmDialog, {
			title: 'Confirm title', subTitle : '',
            message: 'Confirm message'
        }, { dialogType: DialogTypes.Danger })
            .subscribe((isConfirmed) => {
                // We get dialog result
                if (isConfirmed) {
                    alert('accepted');
                } else {
                    alert('declined');
                }
			});
			
        // We can close dialog calling disposable.unsubscribe();
        // If dialog was not closed manually close it by timeout
        setTimeout(() => {
            disposable.unsubscribe();
        }, 10000);
    }



    LicenseChanged(e) {

        this.licenseManager.License().ProductID = (<Product>e.value).ID;

        switch (this.licenseManager.License().BillingCycle) {
            case BillingCycleTypes.Annually:
                this.licenseManager.License().ProductRecurringAmount = (<Product>e.value).PriceYearly;
                break;

            case BillingCycleTypes.Monthly:
                this.licenseManager.License().ProductRecurringAmount = (<Product>e.value).PriceMonthly;
                break;
        }

    }

    GetTransferLog(forceReload: boolean = false) {

        if (this.TransferDetails != null && this.TransferDetails.length > 0 && !forceReload)
            return;


        this.IsBusy = true;
        this.api.SearchTransferLogs(this.licenseManager.License().ID).subscribe(

            (result: BaseResponse<LicenseTransferLogArray>) => {
                this.TransferDetails = result.Data;
                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );

    }

    isValidEndDate(date: any): boolean {
        const parsed = new Date(date);
        return parsed instanceof Date && !isNaN(parsed.getTime()) && parsed.getFullYear() !== 1;
      }

    GetAddOnHistory(forceReload: boolean = false) {

        if (this.AddOnHistoryItems != null && this.AddOnHistoryItems.length > 0 && !forceReload)
            return;


        this.IsBusy = true;
        this.api.AddOnHistory(this.licenseManager.License().ID).subscribe(

            (result: BaseResponse<AddOnHistoryItemArray>) => {
                this.AddOnHistoryItems = result.Data;
                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );

    }


    SimulateUpgradePackage() {
        this.LastUpgradeSimulationType = 'Change Package: ' +
            this.licenseManager.Original().License.ProductName + ' -> ' +
            this.selectedProduct.Name;

        let request = new UpgradeSimulationRequest();
        request.NewPrice = this.licenseManager.License().ProductRecurringAmount;

        if (this.licenseManager.Original().License.BillingCycle == BillingCycleTypes.Monthly &&
            this.licenseManager.License().BillingCycle == BillingCycleTypes.Annually) {
            // from monthly to yearly
            request.UpgradeSimulationType = UpgradeSimulationTypes.MonthToYear;

        } else if (this.licenseManager.Original().License.BillingCycle == BillingCycleTypes.Annually &&
            // from yearly to monthly
            this.licenseManager.License().BillingCycle == BillingCycleTypes.Monthly) {
            request.UpgradeSimulationType = UpgradeSimulationTypes.YearToMonth;

        } else if (this.licenseManager.Original().License.BillingCycle == this.licenseManager.License().BillingCycle) {
            // we keep the biling cycle
            if (this.licenseManager.License().BillingCycle == BillingCycleTypes.Monthly) {
                request.UpgradeSimulationType = UpgradeSimulationTypes.MonthToMonth;
            } else {
                request.UpgradeSimulationType = UpgradeSimulationTypes.YearToYear;
            }

        } else {
            // not supported
            return;
        }


        this.InvokeUpgradeSimulation(request);

    }

    SimulateUpgradeBillingCycle() {
        this.LastUpgradeSimulationType = 'Change Billing Cyclee: ' +
            BillingCycleTypes[this.licenseManager.Original().License.BillingCycle] + ' -> ' +
            BillingCycleTypes[this.licenseManager.License().BillingCycle];


        let request = new UpgradeSimulationRequest();
        request.NewPrice = this.licenseManager.License().ProductRecurringAmount;

        if (this.licenseManager.Original().License.BillingCycle == BillingCycleTypes.Monthly &&
            this.licenseManager.License().BillingCycle == BillingCycleTypes.Annually) {
            // from monthly to yearly
            request.UpgradeSimulationType = UpgradeSimulationTypes.MonthToYear;

        } else if (this.licenseManager.Original().License.BillingCycle == BillingCycleTypes.Annually &&
            // from yearly to monthly
            this.licenseManager.License().BillingCycle == BillingCycleTypes.Monthly) {
            request.UpgradeSimulationType = UpgradeSimulationTypes.YearToMonth;

        } else {
            // not supported
            return;
        }


        this.InvokeUpgradeSimulation(request);

    }

    SimulateUpgradeDueDate() {
        this.LastUpgradeSimulationType = 'Change Due Date: ' +
            this.licenseManager.Original().License.NextBillingDate.toLocaleDateString() + ' -> ' +
            this.licenseManager.License().NextBillingDate.toLocaleDateString();

        let request = new UpgradeSimulationRequest();

        request.UpgradeSimulationType = UpgradeSimulationTypes.ChangeBillingDueDate;
        request.NewDueDate = this.licenseManager.License().NextBillingDate;

        this.InvokeUpgradeSimulation(request);

    }

    InvokeUpgradeSimulation(request: UpgradeSimulationRequest) {

        this.licenseManager.License().NextBillingDate.setHours(0);
        this.licenseManager.License().NextBillingDate.setMinutes(0);
        this.licenseManager.License().NextBillingDate.setSeconds(0);

        request.DecimalPrecisionCalculation = 4;
        request.DecimalPrecisionResult = 2;

        request.CurrentPrice = this.licenseManager.Original().License.ProductRecurringAmount;
        request.NewPrice = this.licenseManager.License().ProductRecurringAmount;
        request.DueDate = this.licenseManager.License().NextBillingDate;
        request.NowDate = new Date();


        this.api.UpgradeSimulation(request).subscribe(
            (result: BaseResponse<UpgradeSimulation>) => {
                this.ConsoleLogUpgradeSumulation(result.Data);

                this.sweetAlertService.swal({
                    title: 'Billing Simulation',
                    type: 'info',
                    html: this.HTML_Template_BillingSimulation(result.Data),
                    showCancelButton: false,
                    showCloseButton: true,
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false
                });

            },

            (error: any) => { }

        );

    }

    HTML_Template_BillingSimulation(data: UpgradeSimulation): string {

        let HTML = `

    ${this.LastUpgradeSimulationType}
    <br>
    <br>
    <ul class="billingSimulation">

    <li>Current Price: <span>$${data.CurrentPrice}</span>
      <div class="subItem">Current Price/Day: <span>$${data.CurrentDayPrice}</span> |
      Current Amount Left Cycle: <span>$${data.AmountLeftCurrentCycle}</span> |
      Current Amount Used Cycle: <span>$${data.AmountUsedCurrentCycle}</span></div>
    </li>

    <li>New Price: <span>$${data.NewPrice}</span>
      <div class="subItem">New Price/Day: <span>$${data.NewDayPrice}</span></div>
    </li>

    <li>Current Due Date: <span>${data.CurrentDueDate.toLocaleDateString()}</span>
      <div class="subItem">Current Cycle Days: <span>${data.CurrentCycleDays}</span> |
      Current Cycle Start Date: <span>${data.CurrentCycleStartDate.toLocaleDateString()}</span></div>
    </li>

    <li>Upgrade invoice amount: <span>$${data.UpgradeInvoice}</span></li>

    </ul>
    <hr>
    <small class="left">
      Days Left Current Cycle: <span>${data.DaysLeftCurrentCycle}</span>
      Days Used Current Cycle: <span>${data.DaysUsedCurrentCycle}</span>
      <br>
      Date Time Now: <span>${data.DateTimeNow.toLocaleDateString()}</span>
      <br>
      Decimal Precision Calculations: <span>${data.DecimalPrecision}</span>
      <br>
      New Cycle Days: <span>${data.NewCycleDays}</span> |
      New Cycle Start Date: <span>${data.NewCycleStartDate.toLocaleDateString()}</span> |
      New Due Date: <span>${data.NewDueDate.toLocaleDateString()}</span>
      <br>

    </small>

    `;

        return HTML;

    }


    ConsoleLogUpgradeSumulation(data: UpgradeSimulation) {
        // console.log('Current Price: ' + data.CurrentPrice);
        // console.log('Current Price / Day: ' + data.CurrentDayPrice);
        // console.log('Current Amount Left Cycle: ' + data.AmountLeftCurrentCycle);
        // console.log('Current Amount Used Cycle: ' + data.AmountUsedCurrentCycle);


        // console.log('Current Due Date: ' + data.CurrentDueDate);
        // console.log('Current Cycle Days: ' + data.CurrentCycleDays);
        // console.log('Current Cycle Start Date: ' + data.CurrentCycleStartDate);

        // console.log('Days Left Current Cycle: ' + data.DaysLeftCurrentCycle);
        // console.log('Days Used Current Cycle: ' + data.DaysUsedCurrentCycle);

        // console.log('Date Time Now: ' + data.DateTimeNow);
        // console.log('Decimal Precision Calculations: ' + data.DecimalPrecision);

        // console.log('New Cycle Days: ' + data.NewCycleDays);
        // console.log('New Cycle Start Date: ' + data.NewCycleStartDate);
        // console.log('New Due Date: ' + data.NewDueDate);

        // console.log('New Price: ' + data.NewPrice);
        // console.log('New Day Price: ' + data.NewDayPrice);

        // console.log('---------------------------------------------------------');
        // console.log('Upgrade invoice amount: ' + data.UpgradeInvoice);
    }

    GetUpgradeLog(forceReload: boolean = false) {

        if (this.UpgradeDetails != null && this.UpgradeDetails.length > 0 && !forceReload)
            return;

        this.IsBusy = true;
        this.api.getUpgradeLogs(this.licenseManager.License().ID).subscribe(

            (result: BaseResponse<LicenseUpgradeLogArray>) => {
                this.UpgradeDetails = result.Data;
                this.IsBusy = false;

            },

            (error: any) => {
                this.IsBusy = false;
            }

        );

    }

    limitTimeToDays(limitTime: any): string {

        let baseMin = limitTime;
        let Days = Math.floor(baseMin / 60 / 24);
        baseMin -= Days * 60 * 24;
        let Hours = Math.floor(baseMin / 60);
        baseMin -= Hours * 60;
        let Minutes = baseMin;

        return Days + 'd ' + Hours + 'h ' + Minutes + 'm';

    }

    SalesRepChanged(e: any) {
        this.salesRepSelected = e;
        this.licenseManager.License().SalesRepresentativeID = e;
        this.licenseManager.Edited();
    }

   // /////////////////////////////////////////////
    // TRIAL STUFF

    TrialEnabled() : boolean {
        if (this.Trial == null)
            return false;
        else
            return this.Trial.InTrial;
    }

    TrialProductChanged(event: any){
        this.TrialProductEdited = true;
    }

    TrialStartChanged(event: any){
        this.TrialStartEdited = true;
    }

    TrialStopChanged(event: any){
        this.TrialStopEdited = true;
    }

    LoadTrial() {
        this.IsBusy = true;

        this.api.GetLicenseTrial(this.licenseManager.License().Key).subscribe(
            (result: IBaseResponse<TrialLicenseResponse>) => {

                if (!result.Result) {
                    // error
                    this.IsBusy = false;
                    return;
                }

                if (result.Data == undefined) {
                    this.IsBusy = false;
                    return;
                }

            
                this.Trial = result.Data;
                if (this.Trial.TrialProducts != null && this.Trial.TrialProducts.length > 0)
                    this.TrialAvailable = true;
                else
                {
                    this.TrialAvailable = false;
                    this.IsBusy = false;
                    return;
                }
            
            
                console.log("trial", this.Trial);
                this.TrialSelectedProduct = this.Trial.TrialProducts[0];
               

                if (this.Trial.InTrial)
                {
                    this.TrialStart = new Date(this.Trial.TrialStart);
                    this.TrialStop = new Date(this.Trial.TrialExpiration);
                }
                else
                {
                    const today = new Date();
                    this.TrialStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                    this.TrialStop = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
                }
                

                this.TrialProducts = [];
                this.Trial.TrialProducts.forEach(product => {
                    this.TrialProducts.push({ label: product.TrialProductName, value: product });
                    if (product.TrialProductName == this.Trial.TrialProductName)
                        this.TrialSelectedProduct = product;

                });        
             


                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );
    }

    // /////////////////////////////////////////////
    // INVOICE STUFF

    LoadInvoices() {
        this.IsBusy = true;

        this.api.GetLicenseInvoices(this.licenseManager.License().ID).subscribe(
            (result: IBaseResponse<InvoiceArray>) => {

                if (!result.Result) {
                    // error
                    this.IsBusy = false;
                    return;
                }

                if (result.Data == undefined) {
                    this.IsBusy = false;
                    return;
                }



                this.Invoices = result.Data;

                this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'DateTimeCreated');

                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );
    }

    ShowInvoiceDetails(Item) {
        let disposable = this.dialogService.addDialog(InvoiceDetailsDialog, {
            title: 'Add New', subTitle : '',
            message: 'Confirm message',
            invoiceItem: Item,
            memberName: this.licenseManager.License().MemberName
        }, { height: 650 }).subscribe(() => {
                disposable.unsubscribe();
            }, error => {
            disposable.unsubscribe();
        });
    }

    DeleteInvoice(Item: Invoice) {
        this.IsBusy = true;

        // confirm
        this.sweetAlertService.swal(
          {
            title: 'Delete Invoice?',
            text: 'Are you really sure you want to do this?',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Do it!',
            showLoaderOnConfirm: true,
            preConfirm: () => {

              return this.api.DeleteInvoices(Item.InvoiceID.toString()).toPromise();

            }
          }).then(response => {
            this.IsBusy = false;

            if (!response.Result) {

              this.sweetAlertService.swal(
                {
                  title: 'Error',
                  text: response.Data,
                  type: 'error',
                  showCancelButton: false,
                  showConfirmButton: true
                })
                .then(response => { })
                .catch(error => { });

              return;
            }

            // ok
            // this.refreshInvoices();

            this.sweetAlertService.swal(
                {
                  title: 'Success',
                  text: 'The invoice is deleted.',
                  type: 'success',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 1500
                })
                .then(response => { })
                .catch(error => { });


          }, (dismiss) => {
            this.IsBusy = false;
            return;
          }); // keep this line to prevent promise error;
    }


    refreshInvoices() {
        this.LoadInvoices();
    }

	

    ShowEditInvoice( Item: Invoice ) {
        let disposable = this.dialogService.addDialog(AddInvoiceDialog, {
            IsEditDialog: true,
            Invoice: Item,
            title: 'Edit', subTitle : '',
            message: 'Confirm message',
			MemberID: this.licenseManager.License().ParentID,
			DashboardData : this._dashboardData,
        }).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
        }, error => {
            disposable.unsubscribe();
        });
    }

    MakePayment( Item: Invoice ) {
        let disposable = this.dialogService.addDialog(MakePaymentDialog, {
            title: 'Add New', subTitle : '',
            message: 'Confirm message',
			invoiceItem: Item,
			creditAmount : this._dashboardData.Credit
          }).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
          }, error => {
            disposable.unsubscribe();
          });
    }


    sortByDate()      { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'DateTimeCreated'); }
    sortByProduct()   { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'Items', 'Description' ); }
    sortByStatus()    { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'Status' ); }

    ClearDeviceID() {
        this.sweetAlertService.swal({
            title: 'Are you sure?',
            text: 'Do you want to clear this device ID from this member account?',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, Clear ID',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            preConfirm: () => {
                return this.api.ClearYardDeviceID(this.licenseManager.License().ID).toPromise();
            }
        }).then(async (response: any) => {
            this.sweetAlertService.swal(
                {
                    title: 'Success',
                    text: 'Device ID Cleared',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                })
                .then((response: any) => {
                    this.YardDeviceIDCleared = true;
                }, () => {
                        this.YardDeviceIDCleared = true;
                        return;
                    }); // keep this line to prevent promise error;
        }, () => {
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => { }, () => { return; }); // keep this line to prevent promise error;
            });

    }

    CanChangeProduct(): boolean {
        let canChange: boolean = true;

        if ( this.licenseManager.License().IsInGracePeriod ) {
            if ( this.roles.RestrictedAccess( UserRoleTypes.Administrator ) )
                canChange = true;
            else
                canChange = false;
        }

        return canChange;
    }


    SaveTrial() {

        var trialRequest = new TrialSetRequest();
        trialRequest.Disable = !this.Trial.InTrial;
        trialRequest.DateTimeStart = this.TrialStart;
        trialRequest.DateTimeStop = this.TrialStop;
        trialRequest.LicenseID =  this.licenseManager.License().ID;
        trialRequest.ProductID = this.TrialSelectedProduct.TrialProductID;

        this.sweetAlertService.swal({
            title: 'Are you sure?',
            text: 'Do you want to change the trial settings for this license?',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            preConfirm: () => {
                return this.api.SetTrial(trialRequest).toPromise();
            }
        }).then(async (response: IBaseResponse<string>) => {

            if (response.Result)
            {
                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'The trial settings are processed',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    }).then((response: any) => { }, () => { return; });
            }
            else
            {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: response.Message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => { }, () => { return; });

            }
        });
    }

}
